import { render, staticRenderFns } from "./ImportButton.vue?vue&type=template&id=4881facc&scoped=true"
import script from "./ImportButton.vue?vue&type=script&lang=ts"
export * from "./ImportButton.vue?vue&type=script&lang=ts"
import style0 from "./ImportButton.vue?vue&type=style&index=0&id=4881facc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881facc",
  null
  
)

export default component.exports